module.exports = "/assets/data/68f6ee9752ea8d366232e6cfe9fb86b5-DE5.data.json";